var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Uploader from "./uploader.vue";
import Component from 'vue-class-component';
import { Prop, Model, Watch } from 'vue-property-decorator';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectedId = "";
        _this.tempFileList = [];
        return _this;
    }
    default_1.prototype.fileListWatch = function () {
        if (this.inputType === 'radio') {
            var record = this.fileList.find(function (item) { return item.selected; });
            if (record) {
                this.selectedId = record[this.fid];
            }
        }
        if (Array.isArray(this.fileList)) {
            this.tempFileList = JSON.parse(JSON.stringify(this.fileList));
        }
    };
    default_1.prototype.change = function () {
        this.$emit("change", JSON.parse(JSON.stringify(this.tempFileList)));
    };
    default_1.prototype.radioChange = function () {
        var _this = this;
        var record = this.tempFileList.find(function (item) { return item[_this.fid] === _this.selectedId; });
        if (record) {
            this.tempFileList.forEach(function (item) { return item.selected = false; });
            record.selected = true;
            this.$emit("change", this.tempFileList);
        }
    };
    __decorate([
        Prop({
            type: String
        })
    ], default_1.prototype, "action", void 0);
    __decorate([
        Prop({
            type: String,
            default: "id"
        })
    ], default_1.prototype, "fid", void 0);
    __decorate([
        Prop({
            type: String,
            default: ""
        })
    ], default_1.prototype, "placeholder", void 0);
    __decorate([
        Prop({
            type: String
        })
    ], default_1.prototype, "defaultLabel", void 0);
    __decorate([
        Prop({
            type: String,
            default: "text"
        })
    ], default_1.prototype, "inputType", void 0);
    __decorate([
        Prop({
            default: 5,
            type: Number
        })
    ], default_1.prototype, "limit", void 0);
    __decorate([
        Prop({
            default: '',
            type: String
        })
    ], default_1.prototype, "removeConfirmTip", void 0);
    __decorate([
        Model("change", {
            required: true,
            type: [Array, Object],
        })
    ], default_1.prototype, "fileList", void 0);
    __decorate([
        Watch("fileList")
    ], default_1.prototype, "fileListWatch", null);
    default_1 = __decorate([
        Component({
            components: {
                Uploader: Uploader
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
